/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Link } from 'gatsby';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { CustomPopover } from '../../../cs/common/components/custom-popover';
import { IZZZCharacter } from '../../../common/model/graphql-types';
import { ZZZCharacterPopover } from './zzz-popover';
import {
  faAnglesUp,
  faArrowDown,
  faArrowUp,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
  employee: IZZZCharacter;
  enablePopover?: boolean;
  showLabel?: boolean;
  showIcon?: boolean;
  showEidolon?: boolean;
  showTierListchange?: boolean;
}

export const ZZZCharacterIcon: React.FC<IProps> = ({
  employee,
  showLabel,
  enablePopover,
  showEidolon,
  showTierListchange
}) => {
  const image = employee.smallImage
    ? getImage(employee.smallImage.localFile.childImageSharp)
    : null;
  return (
    <CustomPopover
      enabled={enablePopover}
      customClass="character-hover-box zzz"
      popover={<ZZZCharacterPopover character={employee} />}
    >
      <Link to={'/zenless/characters/' + employee.slug}>
        <div
          className={`avatar zzz rarity-${employee.rarity} ${
            showLabel ? showLabel : ''
          }`}
        >
          {image && (
            <GatsbyImage
              className="disable-transition"
              image={image}
              alt={`${employee.name}`}
            />
          )}
          {showEidolon && (
            <span className="floating-element zzz">
              <div className="element">
                {employee.element === 'Physical' && (
                  <StaticImage
                    src="../../../../images/zzz/icons/ele_physical.png"
                    alt={employee.element}
                  />
                )}
                {employee.element === 'Fire' && (
                  <StaticImage
                    src="../../../../images/zzz/icons/ele_fire.png"
                    alt={employee.element}
                  />
                )}
                {employee.element === 'Frost' && (
                  <StaticImage
                    src="../../../../images/zzz/icons/ele_frost.png"
                    alt={employee.element}
                  />
                )}
                {employee.element === 'Ice' && (
                  <StaticImage
                    src="../../../../images/zzz/icons/ele_ice.png"
                    alt={employee.element}
                  />
                )}
                {employee.element === 'Ether' && (
                  <StaticImage
                    src="../../../../images/zzz/icons/ele_ether.png"
                    alt={employee.element}
                  />
                )}
                {employee.element === 'Electric' && (
                  <StaticImage
                    src="../../../../images/zzz/icons/ele_electric.png"
                    alt={employee.element}
                  />
                )}
              </div>
            </span>
          )}
          {showEidolon && (
            <span
              className={`floating-element cinema ${
                employee.rarity === 'A' ? 'rarity-A' : 'rarity-S'
              } `}
            >
              {employee.rarity === 'A' ? <>M6</> : <>M0</>}
            </span>
          )}
        </div>
        {showLabel && <span className="emp-name">{employee.name}</span>}
        {showEidolon && employee.tierListTags && (
          <div className="tier-list-tags">
            {employee.tierListTags
              .sort((a, b) => (a > b ? 1 : -1))
              .map((tag, idx) => {
                return (
                  <span key={idx} className={`single-tag ${tag}`}>
                    {idx === employee.tierListTags.length - 1 ? (
                      <>
                        {tag}
                        {tag === 'Expert' && (
                          <FontAwesomeIcon icon={faAnglesUp} width="18" />
                        )}
                      </>
                    ) : (
                      <>
                        {tag}
                        {tag === 'Expert' && (
                          <FontAwesomeIcon icon={faAnglesUp} width="18" />
                        )}
                        ,{' '}
                      </>
                    )}
                  </span>
                );
              })}
          </div>
        )}
        {/* Tier list changes */}
        {showTierListchange && employee.slug === 'vivian' && (
          <span className="floating-element tier-list-hsr new">New</span>
        )}
        {/* {showTierListchange && employee.slug === 'piper' && (
          <>
            <span className="floating-element tier-list-hsr up">
              <FontAwesomeIcon icon={faArrowUp} width="18" />
            </span>
          </>
        )} */}
        {showTierListchange && employee.slug === 'caesar' && (
          <>
            <span className="floating-element tier-list-hsr down">
              <FontAwesomeIcon icon={faArrowDown} width="18" />
            </span>
          </>
        )}
        {showTierListchange && employee.slug === 'ellen' && (
          <>
            <span className="floating-element tier-list-hsr down">
              <FontAwesomeIcon icon={faArrowDown} width="18" />
            </span>
          </>
        )}
        {/* {showTierListchange && (
          <>
            {employee.slug === 'anby-demara-soldier-0' && (
              <>
                <span className="floating-element tier-list-hsr watchlist">
                  <FontAwesomeIcon icon={faEye} width="18" />
                </span>
              </>
            )}
          </>
        )} */}
      </Link>
    </CustomPopover>
  );
};
